<template>
  <div>
    <FilterTab>
      <!-- <template v-slot:title><h6>Counter Man</h6></template> -->
      <template v-slot:body>
        <div class="col-sm-12 col-md-4">
          <label class="text-white">Name</label>
          <input
              v-model="pagination.name"
              placeholder="Enter Name"
              type="text"
              autocomplete="on"
              class="form-control font_detail"
              maxlength="255"
          />
        </div>
        <div class="col-sm-12 col-md-4">
          <label class="text-white">Mobile</label>
          <input
              v-model="pagination.phone"
              placeholder="Enter Mobile"
              type="text"
              autocomplete="on"
              class="form-control font_detail"
              maxlength="255"
          />
        </div>
        <div class="col-md-2 mt-auto">
          <button class="edit_table_data font_detail" @click="getAllCounterMenFilter">
            <i class="fas fa-filter"></i><span class="mx-1 bold">Filter</span>
          </button>
        </div>
      </template>
      <template v-slot:button1>
        <button
          v-if="hasPermission(Admin.companyDeployWrite)"
          class="edit_table_data font_detail"
          @click="addModal"
        >
          <i class="fas fa-plus"></i><span class="mx-1 bold">Add New</span>
        </button>
      </template>
    </FilterTab>
    <Table v-if="$store.getters.getCounterMans">
      <template v-slot:header>
        <tr>
          <td class="font_detail">SL</td>
          <td class="font_detail">NAME</td>
          <td class="font_detail">MOBILE</td>
          <td class="font_detail">EMAIL</td>
          <td class="font_detail">COUNTER</td>
          <td class="font_detail">STATUS</td>
          <td
            v-if="hasPermission(Admin.companyDeployWrite)"
            class="font_detail"
          >
            ACTION
          </td>
        </tr>
      </template>
      <template v-slot:body>
        <tr
          v-for="(counterman, index) in $store.getters.getCounterMans"
          :key="counterman._id"
        >
          <td class="font_detail">
            {{ index + 1 + (pagination.page - 1) * 25 }}
          </td>
          <td class="font_detail">{{ counterman.name }}</td>
          <td class="font_detail">{{ counterman.phone }}</td>
          <td class="font_detail">{{ counterman.email }}</td>
          <td class="font_detail">{{ counterman.counterId.name }}</td>
          <td>
            <span v-if="counterman.status" class="badge bg-success">{{
              dropdownVariables.status[1]
            }}</span>
            <span v-else class="badge bg-danger">{{
              dropdownVariables.status[0]
            }}</span>
          </td>
          <td v-if="hasPermission(Admin.companyDeployWrite)">
            <button
              class="edit_table_data font_detail edit_table_button"
              @click="updateModal(counterman._id)"
            >
              <i class="fas fa-edit"></i><span class="mx-1">Edit</span>
            </button>
          </td>
        </tr>
      </template>
      <template v-slot:pagination>
        <pagination
          v-if="$store.getters.getTotalCounterMans"
          v-model="pagination.page"
          :records="$store.getters.getTotalCounterMans"
          :per-page="pagination.limit"
          @paginate="getAllCounterMans"
          :options="options"
        />
      </template>
    </Table>
    <div v-if="showModal">
      <CountermanAddUpdateModal
        v-model="showModal"
        @getAllCounterMans="getAllCounterMans"
        v-bind:company="companyId"
        v-bind:counterMan="counterManId"
      />
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { useRoute } from "vue-router";
import { onBeforeMount, reactive, ref, inject } from "vue";
import permission from "@/modules/permission";
import roles from "@/modules/roles";
import dropdownVariables from "@/modules/dropdownVariables";
import CountermanAddUpdateModal from "./CountermanAddUpdateModalSeperate.vue";

const { hasPermission } = permission();
const { Admin } = roles();
export default {
  name: "CountermanSeperate",
  components: {
    CountermanAddUpdateModal,
  },
  setup() {
    const companyId = ref("");
    const counterManId = ref("");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const showModal = ref(false);

    const pagination = reactive({
      companyId,
      page: 1,
      limit: 25,
      name: '',
      phone: ''
    });
    const options = {
      texts: {
        count: "",
      },
    };

    const getAllCounterMans = () => {
      showLoader();
      store
        .dispatch("getCounterMansByPage", pagination)
        .then(() => {

        })
        .catch((error) => {
          if (error.status === 401) {
            getAllCounterMans();
          }
        })
        .finally(() => hideLoader());
    };

    const getAllCounterMenFilter = () => {
      pagination.page = 1;
      getAllCounterMans()
    };

    const updateModal = (value) => {
      counterManId.value = value;
      showModal.value = true;
    };
    const addModal = () => {
      counterManId.value = "";
      showModal.value = true;
    };

    const getCounterList = () => {
      showLoader();
      pagination.companyId = useRoute().query.id;
      store.dispatch("getCounterListALL", pagination).then(() => {
        hideLoader();
      });
    };

    onBeforeMount(() => {
      companyId.value = useRoute().query.id;
      getAllCounterMans();
      getCounterList();
    });
    return {
      companyId,
      counterManId,
      pagination,
      getAllCounterMans,
      updateModal,
      hasPermission,
      Admin,
      options,
      dropdownVariables,
      showModal,
      addModal,
      getCounterList,
      getAllCounterMenFilter
    };
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
